<template>
  <div
    v-if="tablesConfigLoaded"
    class="the-page"
  >
    <component
      :is="customPageComponent"
      v-if="customPageComponent"
      @openInModal="openInModal"
    />

    <template v-else>
      <component
        :is="pageBlockComponent"
        v-for="(block, index) of blocks"
        :key="`${pageConfig.url}${block}`"
        :pageUrl="pageConfig.url"
        :entityType="block"
        :showSidebarButton="index === 0"
        @entityClick="editEntity"
        @uploadFile="uploadFile"
        @openInModal="openInModal"
      />
    </template>

    <a-modal
      :class="['table-modal', { fullscreenModal: fullscreenModal, compactModal: compactModal }]"
      :visible="isModalVisible"
      :title="null"
      :footer="null"
      :closable="false"
      :width="compactModal ? 'fit-content' : '1170px'"
      :maskClosable="modalMaskClosable"
      transitionName="none"
      maskTransitionName="none"
      @cancel="onModalClose"
    >
      <component
        :is="modalBlockComponent"
        :pageUrl="modalEntityCode"
        :entityType="modalEntityCode"
        :setupFilters="modalEntityFilters"
        :setupSortParams="modalEntitySortParams"
        :showSidebarButton="false"
        :isUseConfig="false"
        @entityClick="(...args) => editEntity(...args, true)"
        @preventClosing="preventClosing"
        @openInModal="openInModal"
      />
    </a-modal>
  </div>
</template>

<script>
import store from '@/store';
import TableConfigService from '@/services/TableConfigService';
import EntityViewHead from '@/components/edit-form/EntityViewHead';
import PageBlock from './pageblock/PageBlock.vue';
import Log from './log/TheLog';
import MetaForm from '../meta-form/MetaForm';
import PageBlockPublishable from './pageblock/PageBlock_Publishable.vue';
import UploadFile from './pageblock/UploadFile.vue';

export default {
  name: 'ThePage',

  components: {
    PageBlock,
    PageBlockPublishable,
    EntityViewHead,

    // используются как значения свойства customprops.customPage в конфиге страницы:
    Log,
    MetaForm,
  },

  data() {
    return {
      tablesConfigLoaded: false,
      isModalVisible: false,
      pathForModal: null,
      fullscreenModal: false,
      compactModal: false,
      modalEntityCode: null,
      modalEntityFilters: {},
      modalEntitySortParams: {},
      modalBlockComponent: false,
      modalMaskClosable: true,
    };
  },

  computed: {
    fullscreenIcon() {
      return this.fullscreenModal ? 'fullscreen-exit' : 'fullscreen';
    },
    pageConfig() {
      return store.state.activeSidebarItem || {};
    },
    blocks() {
      return this.pageConfig.code ? [this.pageConfig.code] : [];
    },
    customPageComponent() {
      return this.pageConfig?.customprops?.customPage;
    },
    isPublishableEntity() {
      if (!this.pageConfig.code) return false;
      return !!store.state.meta.components[this.pageConfig.code]?.publishable;
    },
    pageBlockComponent() {
      return this.isPublishableEntity ? PageBlockPublishable : PageBlock;
    },
  },
  watch: {
    $route() {
      this.isModalVisible = false;
      this.compactModal = false;
    },
  },

  async created() {
    await TableConfigService.load();
    this.tablesConfigLoaded = true;
  },

  methods: {
    editEntity(...args) {
      if (this.isModalVisible) {
        this.onModalClose(args);
      }
      this.$emit('editEntity', ...args);
    },
    uploadFile(...args) {
      if (this.isModalVisible) {
        this.onModalClose(args);
      }
      this.compactModal = true;
      this.modalBlockComponent = UploadFile;
      this.isModalVisible = true;
    },
    preventClosing(value) {
      this.modalMaskClosable = !value ?? true;
    },
    onModalClose(...args) {
      this.isModalVisible = false;
      this.modalMaskClosable = true;
      this.compactModal = false;
      this.$nextTick(() => {
        this.modalBlockComponent = null;
      });
      const isClickFromModal = args.pop();
      if (isClickFromModal) {
        args[0] = this.modalEntityCode;
      }
    },
    openInModal(path) {
      this.isModalVisible = true;
      this.pathForModal = path;
      this.getDataByPath(path.path);
    },
    getDataByPath(path) {
      const [code, filters] = path.split(/[ ?/]+/).slice(-2);

      this.modalEntityCode = code;
      const b = decodeURIComponent(filters).split(/[&]+/);
      b.forEach((filter) => {
        const [key, value] = filter.split(/[=]+/);
        if (key === 'sort' || key === 'sortDir') {
          this.modalEntitySortParams[key] = value;
        } else {
          this.modalEntityFilters[key] = value;
        }
      });

      const isModalEntityPublishable = !!store.state.meta.components[code]?.publishable;
      this.modalBlockComponent = isModalEntityPublishable ? PageBlockPublishable : PageBlock;
    },
  },
};
</script>

<style lang="scss">
.the-page {
  padding-bottom: 40px;
  padding-left: 10px;
  padding-right: 10px;
  overflow-x: visible;

  .ant-modal-body {
    overflow: hidden;
  }
}

@media (min-width: $desktopBreakpoint) {
  .the-page {
    @include scrollbars();
    height: 100%;
    overflow-y: scroll;

    &.noscroll {
      overflow-y: hidden;
    }
  }

  .menu--vertical .the-page {
    padding-left: 40px;
    padding-right: 26px;

    &.noscroll {
      padding-right: 34px;
    }
  }

  .menu--horizontal .the-page {
    padding-left: 24px;
    padding-right: 24px;

    &.noscroll {
      padding-right: 32px;
    }
  }
}
</style>
